export default {
  fadeIn: {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  },
  fadeOut: {
    from: {
      opacity: 1
    },
    to: {
      opacity: 0
    }
  }
};
